<page-heading
  title="{{ templateName }}"
  description="{{ 'report.templateAnalyticsDetail.category' | translate }}: {{ templateCategory }}"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2 d-flex justify-content-end">
            <div class="col-xs-12 col-lg-2 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.templateAnalyticsDetail.startDate' | translate"
                  formControlName="start"
                />
                <input
                  matEndDate
                  [placeholder]="'report.templateAnalyticsDetail.endDate' | translate"
                  formControlName="end"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'report.templateAnalyticsDetail.select' | translate"
                  >
                    <mat-option value="1">{{ 'report.templateAnalyticsDetail.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'report.templateAnalyticsDetail.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'report.templateAnalyticsDetail.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'report.templateAnalyticsDetail.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'report.templateAnalyticsDetail.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <ul class="nav nav-tabs nav-bordered my-3" role="tablist">
    <li class="nav-item" role="presentation">
      <a
        class="nav-link active"
        id="overview-tab"
        data-bs-toggle="tab"
        data-bs-target="#overview"
        type="button"
        role="tab"
        aria-controls="overview"
        aria-selected="true"
        (click)="selectedView = 'overview'"
      >
        <i
          class="mdi mdi-cloud-download-outline download-icon d-md-none d-block"
        ></i>
        <span class="d-none d-md-inline">{{ 'report.templateAnalyticsDetail.overview' | translate }}</span>
      </a>
    </li>
    <li class="nav-item" role="presentation">
      <a
        class="nav-link"
        id="details-tab"
        data-bs-toggle="tab"
        data-bs-target="#details"
        type="button"
        role="tab"
        aria-controls="details"
        aria-selected="false"
        (click)="selectedView = 'details'"
      >
        <i class="mdi mdi-file-document-outline d-md-none d-block"></i>
        <span class="d-none d-md-inline">{{ 'report.templateAnalyticsDetail.details' | translate }}</span>
      </a>
    </li>
  </ul>

  <div class="tab-content" id="tabComponentsContent">
    <div
      class="tab-pane fade show active custom-scroll-bar"
      id="overview"
      role="tabpanel"
      aria-labelledby="overview-tab"
    >
      @if (selectedView === 'overview') { @if (loadingContent) {
      <content-loading-card />
      } @else if (isDataAnalyticsExists) { @if (!loadingContent) {
      <div class="card-body col-12 mb-3">
        <div class="d-flex flex-column flex-md-row gap-3">
          <div class="flex-fill">
            <card-graphic-small-component
              [label]="'report.templateAnalyticsDetail.estimatedCosts' | translate"
              [icon]="'block'"
              [total]="totalCostCount | currency : currencyCode : 'symbol'"
            />
          </div>
          <div class="flex-fill">
            <card-graphic-small-component
              [label]="'report.templateAnalyticsDetail.perDelivery' | translate"
              [icon]="'block'"
              [total]="totalCostPerDelivery | currency : currencyCode : 'symbol'"
            />
          </div>
          <div class="flex-fill">
            <card-graphic-small-component
              [label]="'report.templateAnalyticsDetail.perClick' | translate"
              [icon]="'block'"
              [total]="totalCostPerClick | currency : currencyCode : 'symbol'"
            />
          </div>
        </div>
      </div>

      <div class="card p-4">
        <div class="row border-bottom pb-3 mb-2">
          <div class="col-12 col-md-4 text-center">
            <h3 class="h5 text-secondary mb-1">{{ 'report.templateAnalyticsDetail.sent' | translate }}</h3>
            <p class="h6 font-weight-bold text-dark">{{ totalSentCount }}</p>
          </div>
          <div class="col-12 col-md-4 text-center">
            <h3 class="h5 text-secondary mb-1">{{ 'report.templateAnalyticsDetail.delivered' | translate }}</h3>
            <p class="h6 font-weight-bold text-dark">
              {{ totalDeliveredCount }}
            </p>
          </div>
          <div class="col-12 col-md-4 text-center">
            <h3 class="h5 text-secondary mb-1">{{ 'report.templateAnalyticsDetail.read' | translate }}</h3>
            <p class="h6 font-weight-bold text-dark">
              {{ totalReadCount }}
              ({{
                (totalReadCount / totalDeliveredCount) * 100 | number : "1.0-2"
              }}%)
            </p>
          </div>
        </div>
        <div class="card-chart">
          <ngx-charts-line-chart
            [scheme]="colorScheme"
            [results]="templateChart"
            [xAxis]="true"
            [yAxis]="true"
            [roundDomains]="true"
            [autoScale]="true"
            [animations]="true"
          ></ngx-charts-line-chart>
        </div>
      </div>
      } } }
    </div>
    <div
      class="tab-pane fade show active custom-scroll-bar"
      id="details"
      role="tabpanel"
      aria-labelledby="details-tab"
    >
      @if (selectedView === 'details') { @if(!loadingContent &&
      templatesDataTable.length > 0) {
      <div class="card">
        <div class="card-body table-responsive">
          <table class="table table-hover table-centered mb-0">
            <thead>
              <tr>
                <th class="text-primary-emphasis">{{ 'report.templateAnalyticsDetail.date' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.templateAnalyticsDetail.sent' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.templateAnalyticsDetail.delivered' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.templateAnalyticsDetail.read' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.templateAnalyticsDetail.clicks' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.templateAnalyticsDetail.deliveryRate' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.templateAnalyticsDetail.costPerClick' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.templateAnalyticsDetail.costPerMessage' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (template of templatesDataTable; track template.id) {
              <tr>
                <td>
                  <span>
                    {{ template.start }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ template.sent }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ template.delivered }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ template.read }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ template.clicked }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ template.deliveryRate }}
                  </span>
                </td>
                <td>
                  {{ template.costPerClick | currency : currencyCode : "symbol" }}
                </td>
                <td>
                  {{
                    template.costPerDelivered | currency : currencyCode : "symbol"
                  }}
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      } }
    </div>
  </div>
</div>
